import React, { lazy, Suspense } from 'react'
import { observer } from 'mobx-react'
import { observable, reaction } from 'mobx'
import {
  customerContainer,
  accountsContainer,
  accountsAddressContainer,
  addressContainer,
  storeContainer,
} from 'src/models'
import { AddressValidation, toastState } from 'src/views/components'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
  getReadOnlyFields,
} from 'src/utils/signUpUtils'
import { Button, Row, Col, Card, Modal, Alert } from 'react-bootstrap'
import {
  i18nTranslate,
  enablePhoneVerificationInProfileUpdate,
} from 'src/utils'
import { AccountProfilePIIForm } from './UserPIIForm/AccountProfilePIIForm'
import { ChangeAccountTypeCard } from './ChangeAccountType/ChangeAccountTypeCard'
import { AccountProfileFormContext } from './context'
import {
  application,
  getLocaleCodeFromUrl,
  getLocalStorage,
  isB2B2CAdmin,
  trackGTMEvents,
  filterWhiteLabelEmails,
  getParsedPhoneNumber,
} from 'src/utils'
import { EmailNotVerifiedSMSVerify } from 'src/views/components/CommonForm/EmailNotVerifiedSMSVerify'
import { EmailVerifiedSMSVerify } from 'src/views/components/CommonForm/EmailVerifiedSMSVerify'
import { PhoneNotVerified } from 'src/views/components/CommonForm/PhoneNotVerified'
import { PhoneVerified } from 'src/views/components/CommonForm/PhoneVerified'
import { PhoneVerificationModal } from 'src/views/components/PhoneVerificationModal/PhoneVerificationModal'
import {
  getAddressFieldsJsonBasedOnCountry,
  checkIfFormIsEmpty,
  checkIfTwoFormValuesAreEqual,
  getAddressOnlyFieldsForValidation,
} from 'src/deps'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { pageNames } from 'src/routes/pathParams'
import './styles.scss'

@observer
class AccountFormIntlShippingSMSVerify extends React.Component {
  @observable combinedFormData = {
    addressData: {},
    PIIData: {},
  }
  @observable AddressFormRef = React.createRef()
  @observable AccountPIIFormRef = React.createRef()
  @observable showPopup = false
  @observable addressFormValid = false
  @observable accountPIIFormValid = false
  @observable addressInvalidFlag = false
  @observable recommendations = []
  @observable popupFormData = {}
  @observable formData = {}
  @observable nonValidAddress = false
  @observable show = false
  @observable isEditProfile = false
  @observable profileDataVal = []
  @observable setCheckPhoneVal = {}
  @observable profileVerifyFormdata = {}
  getlocal = getLocaleCodeFromUrl({
    defaultLocale: 'en_US',
    isReverseType: true,
  })
  country = this.getlocal?.split('_').length ? this.getlocal?.split('_')[1] : ''
  addressDisable = getReadOnlyFields('addressReadOnly', this.country)

  static contextType = AccountProfileFormContext

  FORM = 'FORM'
  POPUP = 'POPUP'
  SUBMIT_BUTTON = 'SUBMIT_BUTTON'
  AddressForm = ''
  currentMarket = storeContainer?.defaultShippingRegion
    ? 'Address' + storeContainer?.defaultShippingRegion
    : 'AddressUS'
  AddressForm = lazy(
    () =>
      import(
        'src/views/addresses/' + this.currentMarket + '/' + this.currentMarket
      )
  )

  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const reactions = reaction(
      () => [this.addressFormValid, this.accountPIIFormValid],
      values => {
        if (values[0] && values[1]) {
          this.makeAPIsIfAllThreeFormsAreValid()
        }
      }
    )
    trackGTMEvents({
      event: 'nuskin-profile',
      eventType: 'Profile-Account',
    })
    this.profileData()
  }

  makeAPIsIfAllThreeFormsAreValid = async () => {
    this.formData = {
      ...this.combinedFormData.addressData,
      ...this.combinedFormData.PIIData,
      ...this.combinedFormData.accTypeData,
    }
    const {
      businessEmail = '',
      email = '',
      postalCode = '',
      zip = '',
      mobilePhoneNumber = '',
      businessPhoneNumber = '',
      stateList = '',
      phoneCountryCode = '',
      firstName,
      lastName,
      state = '',
      wardList = '',
      city = '',
      county = '',
      districtList = '',
      district = '',
      country = '',
      ...remainingProps
    } = this.formData || {}

    accountsAddressContainer.isAccountAddressEmpty = false
    const newEmail = businessEmail || email
    const exEmail = customerContainer.profileResponse?.email || ''

    //Parsing Phone Number...
    const phoneNumber = mobilePhoneNumber || businessPhoneNumber
    const phoneObj =
      (await parsePhoneNumberField(phoneNumber, phoneCountryCode)) || {}

    const phone =
      customerContainer.triggerSaveChangesOnPhoneVerifySuccess &&
      customerContainer.profileSetPhoneNumber
        ? customerContainer.profileSetPhoneNumber
        : phoneObj?.number || ''

    if (this.addressDisable) {
      delete remainingProps.phone
    }
    let addressValidData = {
      phone,
      type: 'Local',
      zip: postalCode?.toUpperCase() || zip,
      email,
      state: stateList || state,
      city: wardList || city,
      county: county || districtList || district,
      country: country || storeContainer?.defaultShippingRegion,
      homeCountry: country || '',
      phoneCountryCode,
      businessEmail,
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      ...remainingProps,
    }

    this.formData.zip = postalCode?.toUpperCase() || zip
    this.formData.state = stateList || state
    this.formData.city = wardList || city
    this.formData.county = county || districtList || district
    this.formData.country = country || storeContainer?.defaultShippingRegion

    delete this.formData?.postalCode
    delete this.formData?.stateList

    const acctype = getLocalStorage('accountType')

    if (this.showPopup === true) {
      this.showPopup = false
      await this.handleCondition(this.popupFormData)
    } else {
      if (
        newEmail === exEmail ||
        acctype === 'Brand Affiliate - Business Entity'
      ) {
        await this.handleCondition(addressValidData)
      } else if (acctype !== 'Brand Affiliate - Business Entity') {
        this.popupFormData = { ...addressValidData }
        this.showPopup = true
      } else {
        await accountsAddressContainer.updateAccountAddress(this.formData)
        await customerContainer.updateForAccountProfile(this.formData)
      }
    }
    this.profileData()
    customerContainer.triggerSaveChangesOnPhoneVerifySuccess = false
  }

  getFormFieldsBasedOnCountry = async () => {
    let fieldJson = await getAddressFieldsJsonBasedOnCountry(this.country)
    let formFields = await getAddressOnlyFieldsForValidation(
      fieldJson,
      'accountProfile'
    )
    return formFields
  }

  checkIfFormFieldsAreEmpty = async (formData = {}) => {
    let formFields = await this.getFormFieldsBasedOnCountry()
    let isFormFieldEmpty =
      (await checkIfFormIsEmpty(formFields, formData)) || false
    let addressLine1 =
      accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''

    return (
      isFormFieldEmpty &&
      (addressLine1 === '' ||
        typeof addressLine1 === 'undefined' ||
        addressLine1 === null)
    )
  }

  isSaveChangesClicked = async () => {
    accountsAddressContainer.currentAddressFormValues = {
      ...this.AddressFormRef.current?.values,
    }
    accountsAddressContainer.isAccountAddressEmpty =
      await this.checkIfFormFieldsAreEmpty(this.AddressFormRef.current?.values)
  }

  handleSubmit = async formData => {
    await this.isSaveChangesClicked()
    if (formData && Object.keys(formData).length > 0) {
      accountsAddressContainer.currentAddressFormValues = {
        ...formData,
      }
    }
    this.addressFormValid = false
    this.accountPIIFormValid = false

    if (accountsContainer.phoneNumberIsValid === false) {
      window.scrollTo(0, 0)
      return
    }

    await this.AddressFormRef.current.handleSubmit()
    const acctype = getLocalStorage('accountType')
    const accountPIIData = this.AccountPIIFormRef.current?.values

    this.setCombinedFormDataForPIIForm(accountPIIData)
    this.accountPIIFormValid = true
  }

  handleSaveChanges = async () => {
    if (accountsContainer.phoneNumberIsValid === false) {
      this.handleSubmit()
      return
    }

    const isPhoneVerified = enablePhoneVerificationInProfileUpdate()
      ? this.setCheckPhoneVal?.phoneCountryCode ===
          customerContainer?.setVerifyPhone?.phoneCountryCode &&
        this.setCheckPhoneVal?.phoneNumber ===
          customerContainer?.setVerifyPhone?.phoneNumber
      : true

    if (isPhoneVerified) {
      this.handleSubmit()
    } else {
      this.profileVerifyFormdata = this.AddressFormRef.current?.values
      customerContainer.triggerSaveChangesOnPhoneVerifySuccess = true
      customerContainer.verifyPhonePopup = true
    }
  }

  handleAddressSubmit = data => {
    this.combinedFormData = {
      ...this.combinedFormData,
      addressData:
        customerContainer.triggerSaveChangesOnPhoneVerifySuccess === false
          ? data
          : this.profileVerifyFormdata,
    }
    this.addressFormValid = true
  }
  setCombinedFormDataForPIIForm = data => {
    const { accountId = '', addressId = '' } =
      accountsContainer?.profileResponse?.addresses?.[0] || {}
    if (
      data?.accountId === '' &&
      data?.addressId === '' &&
      accountId !== '' &&
      addressId !== ''
    ) {
      data.accountId = accountId || ''
      data.addressId = addressId || ''
    }
    this.combinedFormData = { ...this.combinedFormData, PIIData: data }
  }
  handlePIISubmit = data => {
    /**
     * @note
     * On update forms accountId and addressId are not passed
     * assigning with profileResponse
     */
    this.setCombinedFormDataForPIIForm(data)
    this.accountPIIFormValid = true
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.SUBMIT_BUTTON:
        let homeCountry = storeContainer.currentRegion || ''

        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          (element = {}) => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )

        if (homeCountry === 'CA') {
          homeCountry = 'Canada'
        }

        let hideMessage = ''
        if (!isB2B2CAdmin()) {
          hideMessage = 'd-none'
        } else {
          hideMessage =
            homeCountry === storeContainer.storeIDValue ? '' : 'd-none'
        }

        return {
          hideMessageClass: hideMessage,
          showMessageClass:
            homeCountry === storeContainer.storeIDValue
              ? 'd-none'
              : 'non-home-market-country mt-1',
          size: application.isMobile ? 'sm' : 'md',
        }

      default:
        return {}
    }
  }

  handleEditProfile = () => {
    this.isEditProfile = true
  }

  handleCancelProfile = () => {
    this.isEditProfile = false
    this.formData = {}
    this.AccountPIIFormRef?.current?.resetForm()
    this.AddressFormRef?.current?.resetForm()
    window.scrollTo(0, 0)
  }

  renderEditButton = () => {
    const data = this.getDataModal(this.SUBMIT_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)
    return (
      <Row className="border-top">
        <Col className={`${styles?.hideMessageClass}`}>
          <Button
            variant="primary"
            className="addressbook-add-button justify-content-center align-items-center mt-2"
            data-testid="qa-edit-btn"
            size={styles?.size}
            type="submit"
            onClick={() => {
              this.handleEditProfile()
            }}>
            {i18nTranslate('accountProfile.editButton', 'Edit')}
          </Button>
        </Col>
        <div className={styles?.showMessageClass}>{data?.message}</div>
      </Row>
    )
  }

  renderSubmitButton = () => {
    const data = this.getDataModal(this.SUBMIT_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)

    return (
      <div>
        <Col className={`${styles?.hideMessageClass} text-right`}>
          <Button
            variant="primary"
            className="addressbook-add-button justify-content-center align-items-center mt-2"
            data-testid="qa-save-changes"
            size={styles?.size}
            type="submit"
            onClick={this.handleSaveChanges}>
            {data?.saveChangesText}
          </Button>
        </Col>
        <Col className={`${styles?.hideMessageClass} text-right`}>
          <Button
            variant="light"
            className="addressbook-add-button justify-content-center align-items-center mt-2 border border-primary"
            data-testid="qa-cancel-btn"
            size={styles?.size}
            type="submit"
            onClick={() => {
              this.handleCancelProfile()
            }}>
            {i18nTranslate('accountProfile.cancelButton', 'Cancel')}
          </Button>
        </Col>
        <div className={styles?.showMessageClass}>{data?.message}</div>
      </div>
    )
  }

  async getProfileFormData(profileResponse = {}) {
    const { phoneNumber = '' } = profileResponse
    if (phoneNumber != '') {
      const parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

      const phone = parsedPhoneNumber?.phoneNumberCode
      const phoneCountry = parsedPhoneNumber?.phoneCountry

      Object.keys(profileResponse).forEach(item => {
        if (
          item === 'phoneNumber' &&
          typeof profileResponse[item] !== undefined
        ) {
          profileResponse['parsedPhoneNumber'] = phone
        }
      })

      profileResponse['phoneCountry'] = phoneCountry || ''
    }

    return profileResponse
  }

  setProfileData = async () => {
    const accountPrefillData = {
      accountInfo: accountsContainer?.profileResponse,
    }
    const acctype1 = getLocalStorage('accountType')
    const isBusinessEntity = acctype1 === 'Brand Affiliate - Business Entity'
    const identity =
      (await this.getProfileFormData(customerContainer?.profileResponse)) || {} //customerContainer?.profileResponse || {}

    const isEmailVerified =
      identity?.customProperties?.isEmailVerifiedFlag || ''
    let showEmailVerificationStatus = ''
    if (isEmailVerified === 'true') {
      showEmailVerificationStatus = 'valEmail'
    } else {
      showEmailVerificationStatus = 'notValEmail'
    }
    const isPhoneNumberVerified =
      identity?.customProperties?.isPhoneNumberVerified || ''
    let showPhoneVerificationStatus = ''
    if (isPhoneNumberVerified === 'true') {
      showPhoneVerificationStatus = 'valPhone'
    } else {
      showPhoneVerificationStatus = 'notValPhone'
    }

    const identityExist = identity?.accounts
    const {
      name = '',
      typeId,
      size,
      dunsNumber,
      taxNumber,
    } = accountPrefillData?.accountInfo || {}
    const {
      lastName = '',
      phoneNumber = '',
      email = '',
      phoneCountry = '',
      parsedPhoneNumber = '',
    } = identity || {}
    const email2 = identityExist ? getLocalStorage('admnEmail') : ''
    const phoneNumber2 = identityExist ? getLocalStorage('admnPhoneNumber') : ''

    const firstName = isBusinessEntity
      ? identityExist
        ? name
        : ''
      : identity?.firstName
    const accountIdentity = await this.getProfileFormData({
      phoneNumber: accountPrefillData?.accountInfo?.phoneNumber || '',
    })
    const accountPhone = isBusinessEntity
      ? accountIdentity?.parsedPhoneNumber || ''
      : parsedPhoneNumber
    let accountEmail = ''
    if (isBusinessEntity) {
      const properties = accountPrefillData?.accountInfo?.properties || []
      const businessEmailProp = properties.find(
        prop => prop.attributeId === 'businessEmail'
      )
      accountEmail = businessEmailProp?.value || ''
    } else {
      accountEmail = email
    }
    const parsedPhoneCountry = isBusinessEntity
      ? accountIdentity?.phoneCountry
      : phoneCountry
    //Start of parse phonenumber code
    let userCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          userCountry = element.value
        }
      }
    )
    const localCountry = userCountry
      ? userCountry
      : storeContainer?.storeIDValue === 'Canada'
        ? 'CA'
        : storeContainer?.storeIDValue
    let inputCode = countryData()?.find(
      element => element.value === localCountry
    )?.value
    let phoneNumberCode = accountPhone

    if (accountPhone) {
      inputCode = parsedPhoneCountry || inputCode
    }

    const phoneNumberCodeVal = await parsePhoneNumberField(
      phoneNumberCode,
      inputCode
    )
    const phoneCode = phoneNumberCodeVal?.countryCallingCode
      ? '+' + phoneNumberCodeVal?.countryCallingCode
      : ''

    this.setCheckPhoneVal = {
      phoneCountryCode: inputCode,
      phoneNumber: phoneNumberCode,
    }
    const addressDataToDisplay =
      accountsContainer?.profileResponse?.addresses?.[0] || {}

    const addressLine2Value = addressDataToDisplay?.addressLine2
      ? ' ' + addressDataToDisplay?.addressLine2 + ','
      : ''

    const county = addressDataToDisplay?.county
      ? addressDataToDisplay?.county
      : ''

    const country = addressDataToDisplay?.country
      ? addressDataToDisplay?.country
      : ''

    this.profileDataVal = [
      {
        label: i18nTranslate('profileData.name', 'Name'),
        value: isBusinessEntity ? firstName : `${firstName} ${lastName}`,
        dataTestId: 'qa-account-name',
      },
      {
        label: i18nTranslate('profileData.phoneNumber', 'Phone Number'),
        phoneCountry: inputCode,
        value: !isB2B2CAdmin()
          ? phoneNumber2
          : phoneCode && phoneNumberCode
            ? `${phoneCode} ${phoneNumberCode}`
            : '',
        verifyStatus: isB2B2CAdmin() ? showPhoneVerificationStatus : '',
        dataTestId: 'qa-account-phone-number',
      },
      {
        label: i18nTranslate('profileData.email', 'Email'),
        value: filterWhiteLabelEmails({
          email: !isB2B2CAdmin() ? email2 : accountEmail,
        }),
        verifyStatus: isB2B2CAdmin() ? showEmailVerificationStatus : '',
        dataTestId: 'qa-account-email',
      },
      ...(addressDataToDisplay.addressLine1
        ? [
            {
              label: i18nTranslate('profileData.address', 'Address'),
              value: [
                addressDataToDisplay?.addressLine1,
                addressDataToDisplay?.addressLine2,
                addressDataToDisplay?.city,
                county,
                addressDataToDisplay?.state,
                addressDataToDisplay?.zip,
                country,
              ]
                .filter(Boolean)
                .join(', '),
            },
          ]
        : []),
    ]
  }

  profileData = async () => {
    if (Object.keys(customerContainer?.profileResponse)?.length > 0) {
      if (Object.keys(accountsContainer?.profileResponse)?.length > 0) {
        this.setProfileData()
      } else {
        setTimeout(() => {
          this.profileData()
        }, 100)
      }
    } else {
      setTimeout(() => {
        this.profileData()
      }, 100)
    }
  }

  handlePhoneVerify = () => {
    this.profileVerifyFormdata = this.AccountPIIFormRef.current?.values
    customerContainer.verifyPhonePopup = true
  }

  compareUserHomeCountry() {
    let isUserHomeCountry = false
    const selectedLocaleCode = getLocaleCodeFromUrl()?.split('_')?.[1] || {}
    const eqMarketLocales = APPConfig?.getAppConfig()?.eqMarketLocales || ['US']
    let userCountry = customerContainer?.getUserHomeCountry() || ''

    if (selectedLocaleCode === 'undefined') {
      isUserHomeCountry = false
    } else if (selectedLocaleCode != userCountry) {
      isUserHomeCountry = false
    } else {
      isUserHomeCountry = eqMarketLocales?.includes(userCountry?.toLowerCase())
    }
    return isUserHomeCountry
  }

  renderProfileInfo = () => {
    const data = this.getDataModal(this.FORM) || {}

    return (
      <Card
        className={`accountProfileInfoCont mb-3 shadow-sm ${
          this.isEditProfile ? 'd-none' : ''
        }`}
        data-testid={'qa-accountProfile-container'}>
        <Card.Body className="bg-white">
          <h1
            data-testid={'qa-accountProfile-heading'}
            className="card-title heading-2-bold card-title h5">
            {data?.formTitle}
          </h1>
          {this.profileDataVal?.length > 0 &&
            this.profileDataVal?.map((item, index) => {
              if (!item?.value || item?.value === 'undefined') {
                return <></>
              }
              return (
                <Row key={index} className="mb-3">
                  <Col xs={12} className="">
                    <div className="d-flex">
                      <div
                        className={`profileDataLabel ${item?.label} font-weight-bold`}>
                        {item?.label}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="profileDataVal"
                        data-testid={item?.dataTestId ? item?.dataTestId : ''}>
                        {item?.value}
                      </div>
                      {/* {(item?.verifyStatus === 'valEmail' ||
                        item?.verifyStatus === 'valPhone') && (
                        <div className="verifySymbolCont ml-2">
                          <MdVerifiedUser
                            size="1rem"
                            className={`tick-icon green`}
                          />
                        </div>
                      )} */}
                      {/* {(item?.verifyStatus === 'notValEmail' ||
                        item?.verifyStatus === 'notValPhone') && (
                        <div className="verifySymbolCont ml-2">
                          <BsFillExclamationCircleFill
                            size="1rem"
                            className={`tick-icon red`}
                          />
                        </div>
                      )} */}
                    </div>
                    {item?.verifyStatus === 'notValEmail' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <EmailNotVerifiedSMSVerify />
                        </form>
                      )}
                    {item?.verifyStatus === 'valEmail' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <EmailVerifiedSMSVerify />
                        </form>
                      )}
                    {item.verifyStatus === 'valPhone' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <PhoneVerified />
                        </form>
                      )}
                    {item?.verifyStatus === 'notValPhone' &&
                      this.compareUserHomeCountry() && (
                        <>
                          <form>
                            <PhoneNotVerified />
                          </form>
                          {/* <Button
                          variant="light"
                          type="button"
                          onClick={() => {
                            this.handlePhoneVerify()
                          }}
                          data-testid={'qa-verify-btn'}
                          className="myaccount-btn my-2 md-0 border border-primary">
                          {i18nTranslate(
                            'accountProfile.verifyButton',
                            'Verify'
                          )}
                        </Button> */}
                        </>
                      )}
                  </Col>
                </Row>
              )
            })}
          {this.renderEditButton()}
        </Card.Body>
      </Card>
    )
  }

  getDataModal(dataKey) {
    switch (dataKey) {
      case this.FORM:
        const accProperties =
          accountsContainer?.profileResponse?.properties || {}
        const spid =
          !Object.keys(accProperties).length == 0 &&
          accProperties?.find(list => list.attributeId === 'sponsorId')
        const accountsData = customerContainer?.profileResponse?.accounts
        return {
          formTitle: i18nTranslate(
            'accountProfile.lglAddressTitle',
            'Account Information'
          ),
          addressData:
            (accountsData != null &&
              accountsContainer?.profileResponse?.addresses?.[0]) ||
            {},
          addressproPrpperties:
            accountsContainer?.profileResponse?.properties?.[0] || {},
          identity: customerContainer?.profileResponse || {},
          accProperties,
          sponsorId: spid?.value || '',
          accountPrefillData: this.context?.accountPrefillData || {
            accountInfo: accountsContainer?.profileResponse,
          },
          constructStyle: {
            formRowClassName: 'shadow-sm form-card bg-white',
          },
          accountSettings: this.context?.accountSettings,
          isSelfOnBoard: this.context?.isSelfOnBoard,
          buyerAdminMailId: this.context?.buyerAdminMailId,
        }
      case this.SUBMIT_BUTTON:
        return {
          saveChangesText: i18nTranslate(
            'accountProfile.orgAddressSaveButton',
            'Save Changes'
          ),
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
        }
      case this.POPUP:
        return {
          modalTitle: i18nTranslate('emailUpdate', 'Email Update'),
          changeEmailMessage1: i18nTranslate(
            'changeEmailmsg1',
            "You are changing account's primary email for account correspondence and used for logging in."
          ),
          changeEmailMessage2: i18nTranslate(
            'changeEmailmsg2',
            'Are you sure you want to save changes?'
          ),
          proceedText: i18nTranslate('myprofile.proceed', 'Proceed'),
        }
      default:
        return {}
    }
  }

  renderPopup = () => {
    const data = this.getDataModal(this.POPUP)

    return (
      <div>
        <Modal
          show={true}
          onHide={this.handleClosePopup}
          backdrop="static"
          keyboard={false}
          className="modal_box">
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              {data?.modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert className="loyaltyAlert" variant="danger">
              {data?.changeEmailMessage1} {data?.changeEmailMessage2}
            </Alert>
            <Button
              className="confirmBtn mb-2 ml-7"
              variant="primary"
              onClick={() => this.handleSubmitPopup(this.popupFormData)}>
              {data?.proceedText}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    )
  }

  handleClosePopup = () => {
    this.showPopup = false
  }

  handleProcess = async formData => {
    // this.showPopup = false
    const formDataTemp = {
      ...formData,
    }
    let isFormFieldsAreEmpty =
      (await this.checkIfFormFieldsAreEmpty(
        accountsAddressContainer.currentAddressFormValues
      )) || false
    let formFields = await this.getFormFieldsBasedOnCountry()
    const addressData = accountsContainer?.profileResponse?.addresses?.[0] || {}
    if (
      storeContainer.storeIDValue === 'US' ||
      storeContainer.storeIDValue === 'Canada' ||
      formDataTemp.isToMakeValidationApiCall
    ) {
      const isSavedAddressSameAsEnteredAddress =
        await checkIfTwoFormValuesAreEqual(
          formFields,
          formDataTemp,
          addressData
        )
      if (
        !isSavedAddressSameAsEnteredAddress &&
        !isFormFieldsAreEmpty &&
        !this.addressDisable
      ) {
        const res = (await addressContainer.validateAddress(formDataTemp)) || {}
        const recommendationAddress =
          res?.address?.validationDetails?.[0]?.recommendations || []
        let firstAddress = recommendationAddress?.[0] || {}

        if (res?.code === 'ADCOVAL0003' || res.status === 400) {
          this.addressInvalidFlag = true
          this.recommendations = [{ ...formDataTemp }, []]
          this.formDataEnter = { ...formDataTemp }
          this.nonValidAddress = true
          this.show = true
        } else if (res?.code == 'ONESOURCE_ADPLGIN_VAL_ERROR') {
          this.setState({
            show: false,
          })
          toastState.setToastMessage(
            i18nTranslate('address.NotAdded', 'Address not added')
          )
          return
        } else if (res?.code == 'AOACHLD0001') {
          this.setState({
            show: false,
          })
          toastState.setToastMessage(
            i18nTranslate(
              'myaccount.userHoldStatus',
              'There is an issue with your account. Please contact you local account manager.'
            )
          )
          return
        } else {
          let isFirstSuggestedAddressSameAsCurrentAddress =
            checkIfTwoFormValuesAreEqual(formFields, formDataTemp, firstAddress)
          if (!isFirstSuggestedAddressSameAsCurrentAddress) {
            this.addressInvalidFlag = false
            this.recommendations = [
              { ...formDataTemp },
              ...recommendationAddress,
            ]
            this.formDataEnter = { ...formDataTemp }
            this.show = true
          } else {
            this.formDataEnter = { ...formDataTemp }
            await this.handleClickOnPro(formDataTemp)
          }
        }
      } else {
        const addrress1 =
          accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
        const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''

        if (addrress1 === '' && valAdd === '' && !isFormFieldsAreEmpty) {
          await accountsAddressContainer.addAddress(formDataTemp)
        } else {
          const isProfileUpdated = true
          const isAddressUpdated = false
          const reqPayload = await this.filterEditData(
            formData,
            isProfileUpdated,
            isAddressUpdated
          )
        }
        await customerContainer.updateForAccountProfile(formDataTemp)
        this.isEditProfile = false
        this.props.history.push(`${pageNames.b2bAccountProfile}`)
      }
    } else {
      const addrress1 =
        accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
      const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''
      if (addrress1 === '' && valAdd === '' && !isFormFieldsAreEmpty) {
        await accountsAddressContainer.addAddress(formDataTemp)
        await customerContainer.updateForAccountProfile(formDataTemp)
        this.isEditProfile = false
        this.props.history.push(`${pageNames.b2bAccountProfile}`)
      } else if (addrress1 === '' && valAdd === '' && isFormFieldsAreEmpty) {
        const isProfileUpdated = true
        const isAddressUpdated = false
        const reqPayload = await this.filterEditData(
          formData,
          isProfileUpdated,
          isAddressUpdated
        )
        await customerContainer.updateForAccountProfile(formDataTemp)
        this.isEditProfile = false
        this.props.history.push(`${pageNames.b2bAccountProfile}`)
      } else {
        this.formDataEnter = { ...formDataTemp }
        await this.handleClickOnPro(formDataTemp)
      }
    }
  }

  handleCondition = (formData = {}) => {
    return this.handleProcess(formData)
  }

  filterEditData = (
    formData = {},
    isProfileUpdated = true,
    isAddressUpdated = true
  ) => {
    let data = { addressId: formData?.addressId || formData?.id }
    const profileData = accountsContainer?.profileResponse?.customer || ''

    if (isProfileUpdated) {
      if (
        formData?.firstName !== profileData?.firstName &&
        formData?.firstName != ''
      ) {
        data = { ...data, firstName: formData?.firstName || '' }
      }
      if (formData?.lastName !== profileData?.lastName) {
        data = { ...data, lastName: formData?.lastName || '' }
      }
      if (formData?.email !== profileData?.email && formData?.email != '') {
        data = { ...data, email: formData?.email || '' }
      }
      if (formData?.phone !== profileData?.phoneNumber) {
        data = { ...data, phone: formData?.phone || '' }
      }
      if (
        formData?.businessEmail !== profileData?.email &&
        formData?.businessEmail != ''
      ) {
        data = { ...data, businessEmail: formData?.businessEmail || '' }
      }
    }
    if (isAddressUpdated) {
      data = {
        ...data,
        addressLine1: formData?.addressLine1 || '',
        addressLine2: formData?.addressLine2 || '',
        state: formData?.state || '',
        county: formData?.county || '',
        zip: formData?.zip || '',
        country: formData?.country || '',
        city: formData?.city || '',
        email: formData?.email || '',
        phone: formData?.phone || '',
      }
      if (formData?.businessEmail != '') {
        delete data?.email
        data = {
          ...data,
          businessEmail: formData?.businessEmail || '',
        }
      }
    }
    return data
  }

  handleProfileInformationValidation = async (params = {}) => {
    const {
      firstName = '',
      lastName = '',
      businessEmail = '',
      phone = '',
      phoneCountryCode = '',
      email = '',
    } = params
    const profileData = await accountsContainer?.profileResponse?.customer
    const phoneObj =
      (await parsePhoneNumberField(phone, phoneCountryCode)) || {}
    if (profileData !== '') {
      if (
        profileData?.firstName === firstName &&
        profileData?.lastName === lastName &&
        profileData?.email === (email || businessEmail) &&
        profileData?.phoneNumber === phoneObj?.number
      ) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  async handleClickOnPro(formData) {
    const addrress1 =
      accountsContainer?.profileResponse?.addresses?.[0]?.addressLine1 || ''
    const valAdd = accountsContainer?.profileResponse?.addresses?.[0] || ''
    const { email = '', phone = '', phoneCountryCode = '' } = this.formDataEnter
    const accProperties = accountsContainer?.profileResponse?.properties
    const bussinessData =
      accProperties &&
      accProperties.find(list => list.attributeId === 'businessEmail')
    const businessEmail = bussinessData?.value || ''

    const accountPrefillData = {
      accountInfo: accountsContainer?.profileResponse,
    }

    const phonenumber = accountsContainer?.profileResponse?.phoneNumber || ''

    const { dunsNumber } = accountsContainer?.accounts || {}
    const params = {
      email,
      phoneCountryCode: phoneCountryCode || this.formData.phoneCountryCode,
      ...formData,
      phone: phone || phonenumber,
      businessEmail: businessEmail,
      dunsNumber: dunsNumber,
    }
    const isProfileUpdated =
      await this.handleProfileInformationValidation(params)

    const showToastMessage = this.show && isProfileUpdated ? false : true

    if (addrress1 == '' && valAdd == '') {
      if (formData?.selectedIndex <= 0) {
        await accountsAddressContainer?.validateOriginalAccountAddress(
          formData,
          showToastMessage
        )
      } else {
        await accountsAddressContainer?.addAddress(formData, showToastMessage)
      }
    } else {
      const isAddressUpdated = true
      const reqPayload = this.filterEditData(
        params,
        isProfileUpdated,
        isAddressUpdated
      )
      if (formData.selectedIndex <= 0) {
        await accountsAddressContainer.validateUpdatedAddress(
          reqPayload,
          showToastMessage
        )
      } else {
        await accountsAddressContainer.updateAccountAddress(
          reqPayload,
          showToastMessage
        )
      }
    }
    // }

    this.handleClose()
    this.isEditProfile = false
    await customerContainer.updateForAccountProfile(params, isProfileUpdated)
    this.profileData()
    this.props.history.push(`${pageNames.b2bAccountProfile}`)
  }

  handleClose = () => {
    this.show = false
  }

  handleSubmitPopup = (popupFormData = {}) => {
    this.showPopup = false
    this.popupFormData = {}
    this.handleCondition(popupFormData)
  }

  customHandleBlur = async ({ values = {} }) => {
    const phoneNumber = values?.mobilePhoneNumber || values?.businessPhoneNumber
    if (phoneNumber !== '') {
      const phoneNumberCode = await parsePhoneNumberField(
        phoneNumber,
        values?.phoneCountryCode
      )
      const isValidMobile = await validLibMobilePhoneNumber(phoneNumberCode)
      accountsContainer.phoneNumberIsValid = isValidMobile
      customerContainer.setVerifyPhone = {
        ...customerContainer.setVerifyPhone,
        phoneCountryCode: values?.phoneCountryCode,
        phoneNumber: phoneNumber,
      }
    }
  }

  isAddressDisabled = () => {
    let homeCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          homeCountry = element.value
        }
      }
    )
    let storeIdBasedOnCountry = storeContainer.storeIDValue
    storeIdBasedOnCountry =
      storeIdBasedOnCountry.toLowerCase() === 'canada'
        ? 'CA'
        : storeIdBasedOnCountry
    let countryName = homeCountry || storeContainer.storeIDValue
    return !isB2B2CAdmin() || countryName !== storeIdBasedOnCountry
      ? true
      : false
  }

  render() {
    const data = this.getDataModal(this.FORM)
    let isAddressDisabled = this.isAddressDisabled()
    let homeCountry = storeContainer.currentRegion || ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      (element = {}) => {
        if (element?.attributeId === 'countryCode') {
          homeCountry = element?.value
        }
      }
    )
    if (homeCountry === 'CA') {
      homeCountry = 'Canada'
    }
    const isHomeCountry = homeCountry === storeContainer?.storeIDValue || false
    const addressData = accountsContainer?.profileResponse?.addresses?.[0] || ''
    const acctype = getLocalStorage('accountType') || ''
    const isAddressPlainText =
      APPConfig?.getAppConfig()?.enableAddressPlainTextNonHomeCountry ===
        'true' || false

    const accProperties = accountsContainer?.profileResponse?.properties
    const spid =
      accProperties &&
      accProperties.find(list => list.attributeId === 'sponsorId')
    const sponsorId = spid?.value || ''
    if (sponsorId !== 'RETFLOAT') {
      customerContainer?.sponsorIdValidation(sponsorId)
    }
    const upgradeClassName = isHomeCountry ? 'mt-2' : 'd-none'

    const nonHomeCountry = () => {
      return (
        <ul className="non-homecountry-address">
          <li>
            <b>{i18nTranslate('account.homeCountry', 'Home Country')}</b>
            {': '}
            {homeCountry}
          </li>
          <li>
            <b>{i18nTranslate('accountProfile.orgAddressTitle', 'Address')}</b>
            {': '}
          </li>
          {addressData?.addressLine1 && (
            <li>
              {addressData?.addressLine1}, {addressData?.addressLine2 || ''}
              <br />
              {addressData?.city}, {addressData?.state}, {addressData?.zip}
            </li>
          )}
        </ul>
      )
    }
    const isAccountAddressAlreadyExists =
      accountsContainer.profileResponse?.addresses?.length > 0 &&
      accountsContainer.profileResponse?.addresses?.[0]?.addressLine1

    return (
      <React.Fragment>
        <PhoneVerificationModal
          showModal={customerContainer.verifyPhonePopup}
          profileDataPhone={this.setCheckPhoneVal}
          onComplete={this.handleSubmit}
          formData={this.profileVerifyFormdata}
        />
        {this.renderProfileInfo()}
        <div
          className={`accProfileInfoCont ${
            this.isEditProfile ? '' : 'd-none'
          }`}>
          {this.showPopup && this.renderPopup()}
          {this.show && (
            <AddressValidation
              open={this.show}
              addressInvalidFlag={this.addressInvalidFlag}
              recommendations={this.recommendations}
              handleClose={this.handleClose}
              handleClickOnPro={dataAfterValidation =>
                this.handleClickOnPro(dataAfterValidation)
              }
            />
          )}
          {/*Address Form */}
          <AccountProfilePIIForm
            onSubmit={this.handlePIISubmit}
            refId={this.AccountPIIFormRef}
            data={data}
            customHandleBlur={this.customHandleBlur}
            isAddressDisabled={isAddressDisabled}
            onClickPhoneVerifyBtn={this.handlePhoneVerify}
          />
          {isHomeCountry || !isAddressPlainText
            ? IS_BROWSER &&
              this.isEditProfile && (
                <Suspense fallback={<div className="my-2">Loading...</div>}>
                  <this.AddressForm
                    onSubmit={this.handleAddressSubmit}
                    refId={this.AddressFormRef}
                    // addressInfo={data?.accountPrefillData}
                    type={'accountProfile'}
                    isToDisableAddressFields={this.addressDisable}
                    addressInfo={data?.addressData || {}}
                    isSelfOnBoard={data?.isSelfOnBoard}
                    // addressproPrpperties={data?.addressproPrpperties}
                    isAddressDisabled={isAddressDisabled}
                  />
                </Suspense>
              )
            : IS_BROWSER && (
                <Suspense fallback={<div className="my-2">Loading...</div>}>
                  {nonHomeCountry()}
                </Suspense>
              )}
          {this.renderSubmitButton(data)}
        </div>
        <Card
          className={`${upgradeClassName} ${
            this.isEditProfile ? 'd-none' : ''
          }`}>
          <Card.Body className="bg-white">
            <Card.Title>
              <h1 className="card-title heading-2">
                {i18nTranslate('accounts.accountTypeHeading', 'Account Type')}
              </h1>
            </Card.Title>
            {Object.keys(accountsContainer?.profileResponse || {}).length >
              0 && (
              <ChangeAccountTypeCard
                handleShowDownConvertForm={
                  this.props?.handleShowDownConvertForm
                }
                history={this.props?.history || ''}
              />
            )}
          </Card.Body>
        </Card>
      </React.Fragment>
    )
  }
}

export { AccountFormIntlShippingSMSVerify }
export default AccountFormIntlShippingSMSVerify
